import React, { useState, useEffect } from 'react';
import { User } from './types'; // Assuming types.ts is in the same directory or adjust path
import './Admin.css'; // Reusing Admin.css for modal styles

interface EditUserEmailModalProps {
  isOpen: boolean;
  user: User | null;
  onSave: (userId: string, newEmail: string) => void;
  onClose: () => void;
}

const EditUserEmailModal: React.FC<EditUserEmailModalProps> = ({ isOpen, user, onSave, onClose }) => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (user && user.email) {
      setEmail(user.email);
    } else if (user) {
      setEmail(''); // Set to empty if email is undefined for the user
    }
  }, [user]);

  if (!isOpen || !user) {
    return null;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Basic email validation (optional, can be more complex)
    if (!email.includes('@')) {
      alert('Please enter a valid email address.'); // Simple validation, use toast for consistency if preferred
      return;
    }
    onSave(user._id, email);
  };

  return (
    <div className="modal-overlay edit-user-email-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{user.email ? 'Edit' : 'Add'} email for {user.email || user._id}</h3>
          <button onClick={onClose} className="close-button">
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label htmlFor="user-email">Email Address:</label>
            <input
              type="email"
              id="user-email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="modal-footer">
            <button type="submit" className="submit-button">Save Changes</button>
            <button type="button" onClick={onClose} className="cancel-button" /* Assuming cancel-button style exists */ >Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserEmailModal; 